<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <div class="row">
      <div class="col-md-12">
        <pr-input-radio
          formControlName="hasMadeMoreThanFiveMonetairesTransactionsLastYear"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Sur 1 an, avez-vous réalisé plus de 5 transactions ?"
        >
        </pr-input-radio>
      </div>
      <div class="col-md-12">
        <pr-input-radio
          formControlName="isInvestmentOver25KMonetairesLastYear"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Sur 1 an, le montant de vos investissements est-il supérieur à 25 000 € ?"
        >
        </pr-input-radio>
      </div>
    </div>
  </form-wrapper>

  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
